// TODO: Remove this after updating to babel 7.0 and use class syntax.
// Babel 6.* does not handle constructors that return values and therefore does not work as
// expected on errors. Unfortunately, browsers handle this well, so babels behavior does not match
// spec.
//
// TODO: Find out best way to extend Error using TypeScript.
//
// Specifically, if you do `class MyError extends Error { ... }`, then `(new MyError()) instanceof
// MyError` will be false (although `instanceof Error` will be true).
const createErrorType = (name: string): typeof Error => {
  if (typeof window !== 'undefined') {
    class CustomError {
      public static NAME = name;

      public name: string;
      public message: string;
      public stack: string;

      public constructor(message: string) {
        // Fake the properties of a normal Error object.
        this.name = name;
        this.message = message;
        // In some browsers, it may be necessary to throw an Error for it to have a proper stack.
        try {
          throw new Error('');
        } catch (e) {
          this.stack = e.stack;
        }
      }
    }

    CustomError.prototype = Object.create(Error.prototype);
    CustomError.prototype.constructor = CustomError;

    return CustomError as any as typeof Error;
  } else {
    // In this branch, we're running in ts-node so we're not getting transpiled
    // by babel. This means we can just use the standard ES6 class syntax. This
    // is necessary because the assigning to prototype workaround throws an
    // exception under ts-node.
    //
    // While we can check if the environment supports ES6 classes instead of
    // checking for window, when it gets to the browser it will have already
    // been transpiled by babel. So for browsers, it should always use the
    // workaround in the if branch instead.
    class ES6CustomError extends Error {
      public static NAME = name;

      public constructor(message: string) {
        super(message);
        this.name = name;
      }
    }
    // Use 'as' to make TypeScript treat this as an error constructor when type checking, instead of
    // a union type.
    // TODO: Remove this when the Babel branch of this if/else is removed.
    return ES6CustomError as any as typeof Error;
  }
};

export default createErrorType;
